import { Container, Flex, Link, Text } from "@simplybusiness/mobius";
import classNames from "classnames/dedupe";
import type { WithMetadata } from "../../../pages";
import type { FooterProps } from "../types";
import { footerLinks } from "./footerLinks";
import "./Footer.css";

export const Footer = (props: WithMetadata<FooterProps>) => {
  const {
    className,
    phoneNumber,
    openingHours,
    addresses,
    links,
    smallPrint,
    componentName,
    ...otherProps
  } = props;

  const classes = classNames("mobius", "mobius-footer-msm", className);
  const { variant } = otherProps;

  return (
    <footer
      {...otherProps}
      {...(componentName ? { "data-component": componentName } : {})}
      {...(variant ? { "data-variant": variant } : {})}
      className={classes}
    >
      <Container size="sm" className="mobius-footer-msm__content">
        <div className="mobius-footer-msm__logo"></div>
        <Flex className="mobius-footer-msm__links" flexWrap="wrap">
          {footerLinks.map(({ href, text }) => (
            <Link key={href} href={href} target="_blank" rel="nofollow">
              {text}
            </Link>
          ))}
        </Flex>
        <Text variant="legal" className="mobius-footer-msm__small-print">
          {smallPrint}
        </Text>
      </Container>
    </footer>
  );
};
